import React from 'react';

import InformationIcon from '@atlaskit/icon/core/information-circle';
import { Flex } from '@atlaskit/primitives';

export const DetailsPanelHeaderIcon = () => {
	return (
		<Flex alignItems="center">
			<InformationIcon label="" />
		</Flex>
	);
};
